module.exports = __webpack_public_path__ + "static/media/QH.4b79ce6d.svg";